import {
    chakra, Flex
} from '@chakra-ui/react';

export const Notification = chakra(Flex, {
    label: 'Notification',
    baseStyle: {
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        w: 'auto',
        h: '44px',
        cursor: 'pointer',
        ['path']: { fill: 'neutral.400' }
    }
});

export const NotificationsCount = chakra(Flex, {
    label: 'NotificationsCount',
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        width: '14px',
        height: '14px',
        borderRadius: '10px',
        margin: '-7px 0 0 -7px',
        color: 'neutral.50',
        backgroundColor: 'error.600',
        fontSize: '10px'
    }
});
